(() => {
  const config = window.BTSAnalyticsConfig || {};
  const measurementId = config.measurementId;

  const isWhatsAppLink = (link) => {
    const href = link?.href || '';
    return href.includes('wa.me/') || href.includes('api.whatsapp.com/') || href.includes('whatsapp.com/send');
  };

  const getButtonLocation = (link) => {
    if (link.dataset.btsWhatsappSource) return link.dataset.btsWhatsappSource;
    if (link.closest('.chatwith-whatsapp-widget')) return 'floating_button';
    if (link.closest('.bts-hero')) return 'home_hero';
    if (link.closest('.bts-brand-promise')) return 'brand_promise';
    if (link.closest('cart-notification')) return 'cart_notification';
    if (link.closest('cart-drawer')) return 'cart_drawer';
    if (link.closest('.bts-sticky-product')) return 'product_sticky';
    if (link.closest('product-info')) return 'product_main';
    return 'other';
  };

  const getVariantId = (link) => {
    const productRoot = link.closest('product-info, .product__info-container') || document.querySelector('product-info');
    return (
      productRoot?.querySelector('form[action*="/cart/add"] [name="id"]')?.value ||
      link.dataset.btsVariantId ||
      ''
    );
  };

  const sendWhatsAppEvent = (link) => {
    const payload = {
      button_location: getButtonLocation(link),
      page_type: config.pageType || '',
      page_path: window.location.pathname,
      page_title: document.title,
      product_id: link.dataset.btsProductId || '',
      product_handle: link.dataset.btsProductHandle || '',
      product_name: link.dataset.btsProductTitle || '',
      variant_id: getVariantId(link),
      currency: link.dataset.btsCurrency || config.currency || 'ARS',
      product_price: Number(link.dataset.btsValue || 0),
      cart_value: Number(link.dataset.btsCartValue || 0),
      cart_items: Number(link.dataset.btsCartItems || 0),
    };

    if (measurementId) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('event', 'whatsapp_click', {
        ...payload,
        send_to: measurementId,
        transport_type: 'beacon',
      });
    }

    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish('bts_whatsapp_click', payload);
    }

    const sendMetaContact = () => {
      if (typeof window.fbq !== 'function') return false;

      window.fbq('track', 'Contact', {
        content_name: payload.product_name || 'Consulta por WhatsApp',
        content_category: payload.page_type || 'Sitio web',
        button_location: payload.button_location,
        product_id: payload.product_id,
        product_handle: payload.product_handle,
      });

      return true;
    };

    // Meta puede terminar de cargar después del resto del tema.
    if (!sendMetaContact()) {
      window.setTimeout(sendMetaContact, 750);
    }

    if (new URLSearchParams(window.location.search).get('bts_debug') === '1') {
      console.info('[BeTechStyle] whatsapp_click', payload);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a');
      if (!isWhatsAppLink(link)) return;
      sendWhatsAppEvent(link);
    },
    { capture: true }
  );
})();
